export default __webpack_public_path__ + "f82558e5b7a9553f38d495db65c00eb1.svg";